/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LDAPServer
 */
export interface LDAPServer {
    /**
     * 
     * @type {number}
     * @memberof LDAPServer
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof LDAPServer
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LDAPServer
     */
    readonly winbindSeparator: string;
    /**
     * 
     * @type {string}
     * @memberof LDAPServer
     */
    ntDomain?: string;
}

export function LDAPServerFromJSON(json: any): LDAPServer {
    return LDAPServerFromJSONTyped(json, false);
}

export function LDAPServerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LDAPServer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'winbindSeparator': json['winbind_separator'],
        'ntDomain': !exists(json, 'nt_domain') ? undefined : json['nt_domain'],
    };
}

export function LDAPServerToJSON(value?: LDAPServer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'nt_domain': value.ntDomain,
    };
}


